// import plugins here
import themeSwitcher from './theme-switcher';
import basemapSwitcher from './basemap-switcher';
import zoomToBox from './zoom-to-box';
import measureTools from './measure-tools';
import treeView from './tree-view';
// import activeEvent from './active-event';
// import editor from './editor';
import coordDisplay from './coordinate-display';
import zoomHome from './zoom-home';
import zoomInOut from './zoom-in-out';
import rotateNorth from './rotate-north';
import bookmarks from './bookmarks';
// import login from './login';
// import catalog from './catalog';
import identify from './identify';
import legend from './legend';
import threeD from './three-d';
import dsProjects from './ds-projects';
import dsSearch from './ds-search';
import geocoder from './geocoder';
// import cmIdent from './identify-cm';
import esriIdent from './identify-esri';
import geojsonIdent from './identify-geojson';
import addData from './add-data';
import permalink from './permalink';
import vectorIdent from './identify-vector';
import vectorSearch from './vector-search';
// import mapSheetsExplorer from './map-sheets-explorer';
// import mapsOnDemand from './maps-on-demand';
import help from './help';

const corePlugins = {};
corePlugins[btoa(themeSwitcher.pluginName)] = themeSwitcher;
corePlugins[btoa(basemapSwitcher.pluginName)] = basemapSwitcher;
corePlugins[btoa(zoomToBox.pluginName)] = zoomToBox;
corePlugins[btoa(measureTools.pluginName)] = measureTools;
corePlugins[btoa(treeView.pluginName)] = treeView;
// corePlugins[btoa(activeEvent.pluginName)] = activeEvent;
// corePlugins[btoa(editor.pluginName)] = editor;
corePlugins[btoa(coordDisplay.pluginName)] = coordDisplay;
corePlugins[btoa(zoomHome.pluginName)] = zoomHome;
corePlugins[btoa(zoomInOut.pluginName)] = zoomInOut;
corePlugins[btoa(rotateNorth.pluginName)] = rotateNorth;
corePlugins[btoa(bookmarks.pluginName)] = bookmarks;
// corePlugins[btoa(login.pluginName)] = login;
// corePlugins[btoa(catalog.pluginName)] = catalog;
corePlugins[btoa(identify.pluginName)] = identify;
corePlugins[btoa(legend.pluginName)] = legend;
corePlugins[btoa(threeD.pluginName)] = threeD;
corePlugins[btoa(dsProjects.pluginName)] = dsProjects;
corePlugins[btoa(dsSearch.pluginName)] = dsSearch;
corePlugins[btoa(geocoder.pluginName)] = geocoder;
// corePlugins[btoa(cmIdent.pluginName)] = cmIdent;
corePlugins[btoa(esriIdent.pluginName)] = esriIdent;
corePlugins[btoa(geojsonIdent.pluginName)] = geojsonIdent;
corePlugins[btoa(addData.pluginName)] = addData;
corePlugins[btoa(permalink.pluginName)] = permalink;
corePlugins[btoa(vectorIdent.pluginName)] = vectorIdent;
// corePlugins[btoa(vectorSearch.pluginName)] = vectorSearch; DISABLED FOR NOT WORKING 05/15
// corePlugins[btoa(mapSheetsExplorer.pluginName)] = mapSheetsExplorer;
// corePlugins[btoa(mapsOnDemand.pluginName)] = mapsOnDemand;
corePlugins[btoa(help.pluginName)] = help;

const loadRemotePlugin = (url) => {
  const script = window.document.createElement('script');
  script.setAttribute('src', url);
  window.document.head.appendChild(script);
}

// @TODO fix this monkeypatch hack-ity hack
// plugin overrides, always on plugins
const pluginOverrides = [
  {
    pluginName: 'Identify CorpsMap'
  },{
    pluginName: 'Identify GeoJSON'
  },{
    pluginName: 'Identify Vector'
  },{
    pluginName: 'Add Data'
  },{
    pluginName: 'Identify ESRI'
  },{
    pluginName: 'Permalink'
  },{
    pluginName: 'Vector Search'
  }
]

const loaded = [];

export default (store) => {
  store.doStartLoadingPlugins();
  const state = store.getState();
  const plugins = [...state.config.default.plugins, ...pluginOverrides];
  plugins.forEach((plugin) => {
    const sig = btoa(plugin.pluginName);
    if(corePlugins.hasOwnProperty(sig)){
      if(loaded.indexOf(sig) === -1){
        const p = corePlugins[sig];
        if(p.hasOwnProperty('bundle')){
          store.integrateBundles(p.bundle);
        }
        if(p.hasOwnProperty('components')){
          store.doAddPluginComponents(p.components);
        }
        loaded.push(sig);
      }
    }else{
      const match = /https?:\/\//i;
      if(match.test(plugin.pluginName)){
        loadRemotePlugin(plugin.pluginName);
      }
    }
  })
  store.doStopLoadingPlugins();
}